/**
 * A quote the viewer's organisation does not own — one shared into the
 * viewer's project and accepted. The native wizard view asks the owning
 * contractor's questions, so it is withheld on foreign quotes.
 */
export function isForeignQuote(
  quote: { owningSystemOrganisationId: string },
  viewer: { organisation: { id: string } } | null | undefined
): boolean {
  return (
    !!viewer && quote.owningSystemOrganisationId !== viewer.organisation.id
  );
}
